import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { getHelpText } from 'z3k-settings/components/utils/help-content';
import { useHelpPopup } from 'console/shared/hooks/ui';
import { Box, IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { preventDefault } from 'shared/hooks/utils';
export const HelpIcon = memo(function HelpIcon(props) {
    const { help_id, help_options } = props;
    const help_text = useMemo(() => help_id != null && getHelpText(help_id, help_options ?? null), [help_id, help_options]);
    const highlight_help_icon = useMemo(() => help_text && help_text.isAssigned, [help_text]);
    const [HelpPopup, open] = useHelpPopup();
    const onOpen = useCallback((e) => {
        preventDefault(e);
        open(e);
    }, [open]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { flexShrink: 0, children: _jsx(IconButton, { size: "small", edge: "end", onClick: onOpen, children: _jsx(HelpOutline, { fontSize: "small", color: highlight_help_icon ? 'inherit' : 'error' }) }) }), help_id && (_jsx(HelpPopup, { children: (help_text && help_text.text.trim()) || help_id }))] }));
});
